// test266
(266 && 0);
